import type { INotificationButton } from '../hooks/useNotificationState';
import { NotificationState } from '../types';

export const DEFAULT_RESULT = {
  notificationState: NotificationState.NONE,
  messageKey: null,
  button: undefined,
};

export const createResult = (
  state: NotificationState,
  messageKey: string | null,
  button?: INotificationButton
) => ({
  notificationState: state,
  messageKey,
  button,
});

export const OK_BUTTON: INotificationButton = {
  action: 'close',
};
